import { render, staticRenderFns } from "./CursosForm.vue?vue&type=template&id=d6d19922"
import script from "./CursosForm.vue?vue&type=script&lang=js"
export * from "./CursosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports